export default "__VITE_ASSET__DexafvX5__"